import React from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
// import deleteimg from '../../assets/images/delete-icon.png';
import '../../assets/styles/deletePopup.css';
const AddRakeItemConfirmPopup = ({
  onCloseModal,
  open,
  handleConfirm,
  selectedAdmin,
  handleSelectedAdminChange,
  allTeamData,
}) => {
  return (
    <Modal
      className='delete-modal-dialog'
      isOpen={open}
      toggle={onCloseModal}
      style={{ overlay: { opacity: 0.1 } }}
    >
      <ModalHeader
        className='delete-modal-header'
        toggle={onCloseModal}
      ></ModalHeader>
      <ModalBody>
        <h3>
          Are you sure you want to move this Rake item from the inventory to the
          Marketplace?
        </h3>
      </ModalBody>
      <div className='search-category search_category justify-content-center pb-3'>
        <select
          className='category-search'
          name='category'
          value={selectedAdmin}
          onChange={handleSelectedAdminChange}
        >
          <option value='superAdmin'>Move to Marketplace</option>
          {allTeamData &&
            allTeamData?.length > 0 &&
            allTeamData.map((team) => {
              if (team.role[0] !== 'admin') return null;
              return (
                <option key={team._id} value={team?._id}>
                  Send To {team.firstname}
                </option>
              );
            })}
        </select>
      </div>

      <ModalFooter>
        <Button
          type='button'
          color='primary'
          className='delete-button'
          style={{ background: '#ff4d53 !important' }}
          onClick={() => handleConfirm()}
        >
          Confirm
        </Button>
        <Button
          type='button'
          color='secondary'
          className='cancel-button'
          onClick={onCloseModal}
        >
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};
export default AddRakeItemConfirmPopup;
